import { createFileRoute, Link } from '@tanstack/react-router'
import ReactMarkdown from 'react-markdown'
import {useSuspenseQuery} from "@tanstack/react-query"
import { getCompetitionsRetrieveQueryOptions } from "@/api/generated/backendAPI";

export const Route = createFileRoute('/_layout/_auth/competitions/$licenseId/info')({
  loader: ({context: {queryClient}, params}) => {
    return queryClient.ensureQueryData(getCompetitionsRetrieveQueryOptions(params.licenseId))
  },
  component: CompetitionInfo
})

function CompetitionInfo() {
  const { licenseId } = Route.useParams();
  const {data: competitionData} = useSuspenseQuery(getCompetitionsRetrieveQueryOptions(licenseId))

  return (<>
  <ReactMarkdown className="markdown">{competitionData.licensedCompetition.description}</ReactMarkdown>
  <div className='flex items-center justify-center my-16'>
    <Link to="/competitions/$licenseId/submission" params={{licenseId}}><button>投稿する</button></Link>
  </div>
  </>)
}